export const messages = {
  en: {
    'prefs.title': 'Preferences',
    'prefs.hide': 'Hide preferences',
    'prefs.show': 'Show preferences',
    'prefs.accent': 'Accent color',
    'prefs.language': 'Language',
    'prefs.columns': 'Columns',
    'prefs.text': 'Text size',
    'prefs.spacing': 'Spacing',
    'prefs.completed': "Completed todo's",
    'prefs.completedLabel': 'Completed tasks',
    'prefs.showDone': 'Show completed tasks',
    'prefs.hideDone': 'Hide completed tasks',
    'prefs.position': 'Completed position',
    'prefs.bullet': 'Bullet style',
    'prefs.start': 'Start on',
    'prefs.lines': 'Lines',
    'prefs.display': 'Display',
    'accent.red': 'Red',
    'accent.orange': 'Orange',
    'accent.amber': 'Amber',
    'accent.lime': 'Lime',
    'accent.green': 'Green',
    'accent.teal': 'Teal',
    'accent.blue': 'Blue',
    'accent.indigo': 'Indigo',
    'accent.violet': 'Violet',
    'accent.pink': 'Pink',
    'lang.en': 'English',
    'lang.ar': 'العربية',
    'lang.enShort': 'EN',
    'lang.arShort': 'عربي',
    'columns.one': '1 column',
    'columns.many': '{n} columns',
    'size.s': 'Small text',
    'size.m': 'Medium text',
    'size.l': 'Large text',
    'size.sShort': 'S',
    'size.mShort': 'M',
    'size.lShort': 'L',
    'space.s': 'Small spacing',
    'space.m': 'Medium spacing',
    'space.l': 'Large spacing',
    'position.keep': 'Keep',
    'position.end': 'Bottom',
    'position.keepLabel': 'Keep completed tasks in place',
    'position.endLabel': 'Move completed tasks to the bottom',
    'bullet.circle': 'Circle',
    'bullet.square': 'Square',
    'bullet.plus': 'Plus',
    'start.today': 'Today',
    'start.yesterday': 'Yesterday',
    'start.todayLabel': 'Start on today',
    'start.yesterdayLabel': 'Start on yesterday',
    'lines.show': 'Show lines',
    'lines.hide': 'Hide lines',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'nav.search': 'Search tasks',
    'nav.prevWeek': 'Previous week',
    'nav.prevDay': 'Previous day',
    'nav.nextDay': 'Next day',
    'nav.nextWeek': 'Next week',
    'nav.calendar': 'Open calendar',
    'recur.title': 'Recurring to-dos',
    'recur.nav': 'Recurring',
    'recur.create': 'Create a recurring to-do',
    'recur.empty': "You don't have any recurring to-dos yet.",
    'recur.add': 'Recurring to-do',
    'recur.hint': 'Or, type a frequency to the end of a to-do.',
    'recur.frequencies': 'Frequencies:',
    'recur.examples': 'Examples:',
    'recur.freq.day': 'every day',
    'recur.freq.week': 'every week',
    'recur.freq.other': 'every other week',
    'recur.freq.month': 'every month',
    'recur.freq.year': 'every year',
    'recur.ex.day': 'Brush teeth every day',
    'recur.ex.week': 'Management meeting every week',
    'recur.ex.other': 'Piano lessons every other week',
    'recur.ex.month': 'Pay rent every month',
    'recur.ex.year': "Garret's birthday every year",
    'recur.repeat': 'Repeat every',
    'recur.unit': 'Unit',
    'recur.start': 'Start on',
    'recur.save': 'Save',
    'recur.cancel': 'Cancel',
    'recur.viewAll': 'View all',
    'recur.close': 'Close',
    'recur.one.day': 'day',
    'recur.one.week': 'week',
    'recur.one.month': 'month',
    'recur.one.year': 'year',
    'recur.many.day': 'days',
    'recur.many.week': 'weeks',
    'recur.many.month': 'months',
    'recur.many.year': 'years',
    'recur.every.day': 'every day',
    'recur.every.week': 'every week',
    'recur.every.month': 'every month',
    'recur.every.year': 'every year',
    'recur.everyOtherWeek': 'every other week',
    'recur.everyOtherDay': 'every other day',
    'recur.everyN.day': 'every {n} days',
    'recur.everyN.week': 'every {n} weeks',
    'recur.everyN.month': 'every {n} months',
    'recur.everyN.year': 'every {n} years',
    'nav.backOne': 'Back one day',
    'nav.forwardOne': 'Forward one day',
    'nav.backMany': 'Back {n} days',
    'nav.forwardMany': 'Forward {n} days',
    'status.days': 'Visible days',
    'status.today': 'Back to today',
    'status.account': 'Account',
    'status.full': 'Full screen',
    'status.shortcuts': 'Keyboard shortcuts',
    'status.pro': 'GO PRO',
    'status.proActive': 'PRO',
    'task.add': 'Add a task',
    'task.done': 'Mark as done',
    'task.undone': 'Mark as not done',
    'task.details': 'More details',
    'task.delete': 'Delete task',
    'task.highlight': 'Highlight',
    'task.color.gray': 'Gray',
    'task.color.red': 'Red',
    'task.color.orange': 'Orange',
    'task.color.yellow': 'Yellow',
    'task.color.green': 'Green',
    'task.color.teal': 'Teal',
    'task.color.blue': 'Blue',
    'task.color.indigo': 'Indigo',
    'task.color.purple': 'Purple',
    'task.color.pink': 'Pink',
    'task.color.none': 'No color',
    'task.label': 'Task',
    'lists.label': 'Lists',
    'lists.pages': 'List pages',
    'lists.pageName': 'Page name',
    'lists.rename': 'Double-click to rename',
    'lists.pageHint': 'Double-click to rename. Right-click to delete.',
    'lists.manageTab': 'Manage tab',
    'lists.manageLists': 'Manage lists in tab',
    'lists.renameTab': 'Rename tab',
    'lists.done': 'Done',
    'lists.close': 'Close',
    'lists.renameList': 'Rename list',
    'lists.dragList': 'Drag to reorder',
    'lists.add': 'Add',
    'lists.newList': 'New list',
    'lists.prev': 'Previous list',
    'lists.next': 'Next list',
    'lists.prevMany': 'Back {n} lists',
    'lists.nextMany': 'Forward {n} lists',
    'lists.newPage': 'New page',
    'lists.deletePage': 'Delete page',
    'lists.collapse': 'Collapse lists',
    'lists.expand': 'Expand lists',
    'lists.list': 'List',
    'lists.untitled': 'Untitled',
    'lists.listName': '{name} list name',
    'lists.delete': 'Delete {name}',
    'lists.create': 'Create a list',
    'lists.resize': 'Resize lists',
    'detail.title': 'Task details',
    'detail.bold': 'Bold',
    'detail.italic': 'Italic',
    'detail.link': 'Insert link',
    'detail.linkPrompt': 'Link address',
    'detail.check': 'Insert checkbox',
    'detail.image': 'Insert image',
    'detail.chooseImage': 'Choose an image',
    'detail.notes': 'Notes',
    'detail.placeholder': 'Add notes',
    'search.label': 'Search tasks',
    'search.placeholder': 'Search tasks',
    'search.clear': 'Clear',
    'search.hint': 'Search across days and lists.',
    'search.empty': 'No matching tasks.',
    'search.lists': 'Lists',
    'cal.label': 'Calendar',
    'cal.prev': 'Previous month',
    'cal.next': 'Next month',
    'account.label': 'Account',
    'account.name': 'Name',
    'account.waitlist': "You're on the Pro list.",
    'account.shortcuts': 'Keyboard shortcuts',
    'account.cancel': 'Cancel',
    'account.reset': 'Reset',
    'account.resetBoard': 'Reset board',
    'account.signOut': 'Sign out',
    'account.admin': 'Admin',
    'auth.signIn': 'Sign in',
    'auth.create': 'Create account',
    'auth.name': 'Name',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.passwordHint': 'At least 10 characters.',
    'auth.submitIn': 'Sign in',
    'auth.submitUp': 'Create account',
    'auth.switchToUp': 'Need an account?',
    'auth.switchToIn': 'Already have an account?',
    'auth.switchUp': 'Create one',
    'auth.switchIn': 'Sign in',
    'auth.working': 'Working…',
    'auth.invalid_credentials': 'Email or password is incorrect.',
    'auth.email_taken': 'An account with that email already exists.',
    'auth.invalid_email': 'Enter a valid email address.',
    'auth.weak_password': 'Use at least 10 characters.',
    'auth.invalid_name': 'Enter a name up to 80 characters.',
    'auth.rate_limited': 'Too many attempts. Wait a few minutes and try again.',
    'auth.network': 'Cannot reach the server.',
    'sync.offline': 'Offline',
    'sync.error': 'Not synced',
    'auth.retry': 'Try again',
    'auth.server': 'Something went wrong. Try again.',
    'undo.task': 'Task removed',
    'undo.page': 'Page removed',
    'undo.list': 'List removed',
    'undo.action': 'Undo',
    'keys.kicker': 'KEYS',
    'keys.title': 'Shortcuts',
    'keys.done': 'Done',
    'keys.next': 'Next line',
    'keys.delete': 'Delete an empty line',
    'keys.move': 'Move between lines',
    'keys.reorder': 'Reorder a task',
    'keys.search': 'Search',
    'keys.today': 'Jump to today',
    'keys.day': 'Previous / next day',
    'keys.prefs': 'Toggle preferences',
    'keys.close': 'Close a panel',
    'pro.kicker': 'PRO',
    'pro.title': 'A quieter place to plan the week.',
    'pro.lede': 'Choose how you would like to be billed. You can change or cancel whenever you like.',
    'pro.subscribe': 'Subscribe',
    'pro.manage': 'Manage billing',
    'pro.current': 'Current plan',
    'pro.perMonth': 'per month',
    'pro.perYear': 'per year',
    'pro.opening': 'Opening checkout…',
    'pro.unavailable': 'Payments are unavailable right now.',
    'pro.already': 'This account already has a subscription.',
    'billing.working': 'Confirming your subscription…',
    'billing.active': 'Your subscription is active.',
    'billing.cancel': 'Checkout was canceled.',
    'billing.error': 'The payment could not be confirmed.',
    'billing.dismiss': 'Dismiss',
    'pro.reminders': 'Reminders that stay out of the way',
    'pro.pages': 'Unlimited list pages',
    'pro.themes': 'Themes beyond light and dark',
    'pro.later': 'Not now',
    'pro.joined': "You're on the list",
    'pro.join': 'Join the list',
    'admin.kicker': 'Billing',
    'admin.back': 'Back to board',
    'admin.overview': 'Overview',
    'admin.users': 'Users',
    'admin.plans': 'Plans',
    'admin.subscriptions': 'Subscriptions',
    'admin.transactions': 'Transactions',
    'admin.mrr': 'Estimated MRR',
    'admin.activeSubs': 'Active subscriptions',
    'admin.collected': 'Collected this month',
    'admin.activePlans': 'Active plans',
    'admin.stripe': 'Stripe is not connected yet. Plans, subscriptions, and payments recorded here are ready for it.',
    'admin.stripeTest': 'Stripe test mode is connected. Every payment is saved in this log.',
    'admin.stripeLive': 'Stripe live mode is connected. Every payment is saved in this log.',
    'admin.webhookOff': 'Add the webhook secret so renewals and refunds are recorded on their own.',
    'admin.payments': 'Payments',
    'admin.events': 'Stripe events',
    'admin.search': 'Search',
    'admin.from': 'From',
    'admin.to': 'To',
    'admin.min': 'Min',
    'admin.max': 'Max',
    'admin.any': 'Any',
    'admin.apply': 'Apply',
    'admin.clear': 'Clear',
    'admin.matches': '{n} matches',
    'admin.noMatches': 'Nothing matches these filters.',
    'admin.loadMore': 'Load more',
    'admin.stripeId': 'Stripe',
    'admin.event': 'Event',
    'admin.message': 'Message',
    'admin.recent': 'Recent transactions',
    'admin.empty': 'Nothing here yet.',
    'admin.loading': 'Loading…',
    'admin.forbidden': 'You do not have access to the admin dashboard.',
    'admin.loadError': 'The dashboard could not be loaded.',
    'admin.saveError': 'Could not save that. Check the fields and try again.',
    'admin.userMissing': 'No account uses that email.',
    'admin.role': 'Role',
    'admin.role.user': 'Member',
    'admin.role.admin': 'Admin',
    'admin.joined': 'Joined',
    'admin.you': 'You',
    'admin.noPlan': 'No plan',
    'admin.deleteUser': 'Delete',
    'admin.confirmDelete': 'Delete account',
    'admin.lastAdmin': 'Keep at least one admin.',
    'admin.showProPlans': 'Show plans on Get Pro',
    'admin.newPlan': 'New plan',
    'admin.editPlan': 'Edit plan',
    'admin.newSub': 'New subscription',
    'admin.newTx': 'New transaction',
    'admin.save': 'Save',
    'admin.saving': 'Saving…',
    'admin.cancel': 'Cancel',
    'admin.name': 'Name',
    'admin.description': 'Description',
    'admin.price': 'Price',
    'admin.currency': 'Currency',
    'admin.interval': 'Billing',
    'admin.month': 'Monthly',
    'admin.year': 'Yearly',
    'admin.active': 'Active',
    'admin.inactive': 'Hidden',
    'admin.customer': 'Customer email',
    'admin.status': 'Status',
    'admin.periodEnd': 'Period ends',
    'admin.amount': 'Amount',
    'admin.note': 'Note',
    'admin.plan': 'Plan',
    'admin.when': 'Date',
    'admin.stripePrice': 'Stripe price ID',
    'admin.optional': 'Leave blank and Stripe will create the price.',
    'admin.paidCount': '{n} succeeded',
    'admin.status.trialing': 'Trialing',
    'admin.status.active': 'Active',
    'admin.status.past_due': 'Past due',
    'admin.status.canceled': 'Canceled',
    'admin.status.incomplete': 'Incomplete',
    'admin.status.pending': 'Pending',
    'admin.status.succeeded': 'Succeeded',
    'admin.status.failed': 'Failed',
    'admin.status.refunded': 'Refunded',
    'admin.status.paused': 'Paused',
    'admin.status.processed': 'Processed',
    'admin.status.ignored': 'Ignored',
  },
  ar: {
    'prefs.title': 'التفضيلات',
    'prefs.hide': 'إخفاء التفضيلات',
    'prefs.show': 'إظهار التفضيلات',
    'prefs.accent': 'لون التمييز',
    'prefs.language': 'اللغة',
    'prefs.columns': 'الأعمدة',
    'prefs.text': 'حجم الخط',
    'prefs.spacing': 'المسافة',
    'prefs.completed': 'المكتملة',
    'prefs.completedLabel': 'المهام المكتملة',
    'prefs.showDone': 'إظهار المهام المكتملة',
    'prefs.hideDone': 'إخفاء المهام المكتملة',
    'prefs.position': 'ترتيب المكتمل',
    'prefs.bullet': 'النقطة',
    'prefs.start': 'البداية',
    'prefs.lines': 'الخطوط',
    'prefs.display': 'المظهر',
    'accent.red': 'أحمر',
    'accent.orange': 'برتقالي',
    'accent.amber': 'عنبري',
    'accent.lime': 'ليموني',
    'accent.green': 'أخضر',
    'accent.teal': 'تركوازي',
    'accent.blue': 'أزرق',
    'accent.indigo': 'نيلي',
    'accent.violet': 'بنفسجي',
    'accent.pink': 'وردي',
    'lang.en': 'English',
    'lang.ar': 'العربية',
    'lang.enShort': 'EN',
    'lang.arShort': 'عربي',
    'columns.one': 'عمود واحد',
    'columns.many': '{n} أعمدة',
    'size.s': 'خط صغير',
    'size.m': 'خط متوسط',
    'size.l': 'خط كبير',
    'size.sShort': 'ص',
    'size.mShort': 'م',
    'size.lShort': 'ك',
    'space.s': 'مسافة صغيرة',
    'space.m': 'مسافة متوسطة',
    'space.l': 'مسافة كبيرة',
    'position.keep': 'كما هي',
    'position.end': 'الأسفل',
    'position.keepLabel': 'إبقاء المهام المكتملة في مكانها',
    'position.endLabel': 'نقل المهام المكتملة إلى الأسفل',
    'bullet.circle': 'دائرة',
    'bullet.square': 'مربع',
    'bullet.plus': 'زائد',
    'start.today': 'اليوم',
    'start.yesterday': 'أمس',
    'start.todayLabel': 'البدء من اليوم',
    'start.yesterdayLabel': 'البدء من أمس',
    'lines.show': 'إظهار الخطوط',
    'lines.hide': 'إخفاء الخطوط',
    'theme.light': 'فاتح',
    'theme.dark': 'داكن',
    'nav.search': 'بحث في المهام',
    'nav.prevWeek': 'الأسبوع السابق',
    'nav.prevDay': 'اليوم السابق',
    'nav.nextDay': 'اليوم التالي',
    'nav.nextWeek': 'الأسبوع التالي',
    'nav.calendar': 'فتح التقويم',
    'recur.title': 'المهام المتكررة',
    'recur.nav': 'متكررة',
    'recur.create': 'أنشئ مهمة متكررة',
    'recur.empty': 'ليس لديك مهام متكررة بعد.',
    'recur.add': 'مهمة متكررة',
    'recur.hint': 'أو اكتب التكرار في نهاية المهمة.',
    'recur.frequencies': 'التكرار:',
    'recur.examples': 'أمثلة:',
    'recur.freq.day': 'كل يوم',
    'recur.freq.week': 'كل أسبوع',
    'recur.freq.other': 'كل أسبوعين',
    'recur.freq.month': 'كل شهر',
    'recur.freq.year': 'كل سنة',
    'recur.ex.day': 'تنظيف الأسنان كل يوم',
    'recur.ex.week': 'اجتماع الإدارة كل أسبوع',
    'recur.ex.other': 'درس البيانو كل أسبوعين',
    'recur.ex.month': 'دفع الإيجار كل شهر',
    'recur.ex.year': 'عيد ميلاد غريت كل سنة',
    'recur.repeat': 'تكرار كل',
    'recur.unit': 'الوحدة',
    'recur.start': 'تبدأ في',
    'recur.save': 'حفظ',
    'recur.cancel': 'إلغاء',
    'recur.viewAll': 'عرض الكل',
    'recur.close': 'إغلاق',
    'recur.one.day': 'يوم',
    'recur.one.week': 'أسبوع',
    'recur.one.month': 'شهر',
    'recur.one.year': 'سنة',
    'recur.many.day': 'أيام',
    'recur.many.week': 'أسابيع',
    'recur.many.month': 'أشهر',
    'recur.many.year': 'سنوات',
    'recur.every.day': 'كل يوم',
    'recur.every.week': 'كل أسبوع',
    'recur.every.month': 'كل شهر',
    'recur.every.year': 'كل سنة',
    'recur.everyOtherWeek': 'كل أسبوعين',
    'recur.everyOtherDay': 'كل يومين',
    'recur.everyN.day': 'كل {n} أيام',
    'recur.everyN.week': 'كل {n} أسابيع',
    'recur.everyN.month': 'كل {n} أشهر',
    'recur.everyN.year': 'كل {n} سنوات',
    'nav.backOne': 'رجوع يوم',
    'nav.forwardOne': 'تقدم يوم',
    'nav.backMany': 'رجوع {n} أيام',
    'nav.forwardMany': 'تقدم {n} أيام',
    'status.days': 'الأيام الظاهرة',
    'status.today': 'العودة إلى اليوم',
    'status.account': 'الحساب',
    'status.full': 'ملء الشاشة',
    'status.shortcuts': 'اختصارات لوحة المفاتيح',
    'status.pro': 'برو',
    'status.proActive': 'برو',
    'task.add': 'أضف مهمة',
    'task.done': 'تعليم كمكتملة',
    'task.undone': 'تعليم كغير مكتملة',
    'task.details': 'تفاصيل أكثر',
    'task.delete': 'حذف المهمة',
    'task.highlight': 'تمييز',
    'task.color.gray': 'رمادي',
    'task.color.red': 'أحمر',
    'task.color.orange': 'برتقالي',
    'task.color.yellow': 'أصفر',
    'task.color.green': 'أخضر',
    'task.color.teal': 'تركوازي',
    'task.color.blue': 'أزرق',
    'task.color.indigo': 'نيلي',
    'task.color.purple': 'بنفسجي',
    'task.color.pink': 'وردي',
    'task.color.none': 'بلا لون',
    'task.label': 'مهمة',
    'lists.label': 'القوائم',
    'lists.pages': 'صفحات القوائم',
    'lists.pageName': 'اسم الصفحة',
    'lists.rename': 'انقر مرتين لإعادة التسمية',
    'lists.pageHint': 'انقر مرتين لإعادة التسمية. انقر بالزر الأيمن للحذف.',
    'lists.manageTab': 'إدارة التبويب',
    'lists.manageLists': 'إدارة القوائم في التبويب',
    'lists.renameTab': 'إعادة تسمية التبويب',
    'lists.done': 'تم',
    'lists.close': 'إغلاق',
    'lists.renameList': 'إعادة تسمية القائمة',
    'lists.dragList': 'اسحب لإعادة الترتيب',
    'lists.add': 'إضافة',
    'lists.newList': 'قائمة جديدة',
    'lists.prev': 'القائمة السابقة',
    'lists.next': 'القائمة التالية',
    'lists.prevMany': 'رجوع {n} قوائم',
    'lists.nextMany': 'تقدم {n} قوائم',
    'lists.newPage': 'صفحة جديدة',
    'lists.deletePage': 'حذف الصفحة',
    'lists.collapse': 'طي القوائم',
    'lists.expand': 'توسيع القوائم',
    'lists.list': 'قائمة',
    'lists.untitled': 'بدون عنوان',
    'lists.listName': 'اسم قائمة {name}',
    'lists.delete': 'حذف {name}',
    'lists.create': 'أنشئ قائمة',
    'lists.resize': 'تغيير ارتفاع القوائم',
    'detail.title': 'تفاصيل المهمة',
    'detail.bold': 'عريض',
    'detail.italic': 'مائل',
    'detail.link': 'إدراج رابط',
    'detail.linkPrompt': 'عنوان الرابط',
    'detail.check': 'إدراج مربع اختيار',
    'detail.image': 'إدراج صورة',
    'detail.chooseImage': 'اختيار صورة',
    'detail.notes': 'ملاحظات',
    'detail.placeholder': 'أضف ملاحظات',
    'search.label': 'بحث في المهام',
    'search.placeholder': 'ابحث في المهام',
    'search.clear': 'مسح',
    'search.hint': 'ابحث في الأيام والقوائم.',
    'search.empty': 'لا توجد مهام مطابقة.',
    'search.lists': 'القوائم',
    'cal.label': 'التقويم',
    'cal.prev': 'الشهر السابق',
    'cal.next': 'الشهر التالي',
    'account.label': 'الحساب',
    'account.name': 'الاسم',
    'account.waitlist': 'أنت على قائمة برو.',
    'account.shortcuts': 'اختصارات لوحة المفاتيح',
    'account.cancel': 'إلغاء',
    'account.reset': 'إعادة التعيين',
    'account.resetBoard': 'إعادة تعيين اللوحة',
    'account.signOut': 'تسجيل الخروج',
    'account.admin': 'الإدارة',
    'auth.signIn': 'تسجيل الدخول',
    'auth.create': 'إنشاء حساب',
    'auth.name': 'الاسم',
    'auth.email': 'البريد',
    'auth.password': 'كلمة المرور',
    'auth.passwordHint': 'عشرة أحرف على الأقل.',
    'auth.submitIn': 'دخول',
    'auth.submitUp': 'إنشاء الحساب',
    'auth.switchToUp': 'ليس لديك حساب؟',
    'auth.switchToIn': 'لديك حساب؟',
    'auth.switchUp': 'أنشئ حساباً',
    'auth.switchIn': 'سجّل الدخول',
    'auth.working': 'جارٍ العمل…',
    'auth.invalid_credentials': 'البريد أو كلمة المرور غير صحيحة.',
    'auth.email_taken': 'يوجد حساب بهذا البريد.',
    'auth.invalid_email': 'أدخل بريداً صالحاً.',
    'auth.weak_password': 'استخدم عشرة أحرف على الأقل.',
    'auth.invalid_name': 'أدخل اسماً لا يتجاوز 80 حرفاً.',
    'auth.rate_limited': 'محاولات كثيرة. انتظر بضع دقائق ثم أعد المحاولة.',
    'auth.network': 'تعذر الاتصال بالخادم.',
    'sync.offline': 'دون اتصال',
    'sync.error': 'لم تتم المزامنة',
    'auth.retry': 'حاول مرة أخرى',
    'auth.server': 'حدث خطأ. حاول مرة أخرى.',
    'undo.task': 'تم حذف المهمة',
    'undo.page': 'تم حذف الصفحة',
    'undo.list': 'تم حذف القائمة',
    'undo.action': 'تراجع',
    'keys.kicker': 'المفاتيح',
    'keys.title': 'الاختصارات',
    'keys.done': 'تم',
    'keys.next': 'السطر التالي',
    'keys.delete': 'حذف سطر فارغ',
    'keys.move': 'التنقل بين الأسطر',
    'keys.reorder': 'إعادة ترتيب مهمة',
    'keys.search': 'بحث',
    'keys.today': 'الانتقال إلى اليوم',
    'keys.day': 'اليوم السابق / التالي',
    'keys.prefs': 'إظهار التفضيلات',
    'keys.close': 'إغلاق لوحة',
    'pro.kicker': 'برو',
    'pro.title': 'مكان أهدأ لتخطيط الأسبوع.',
    'pro.lede': 'اختر طريقة الدفع. يمكنك تغيير الباقة أو إلغاءها في أي وقت.',
    'pro.subscribe': 'اشترك',
    'pro.manage': 'إدارة الفوترة',
    'pro.current': 'الباقة الحالية',
    'pro.perMonth': 'شهريًا',
    'pro.perYear': 'سنويًا',
    'pro.opening': 'جارٍ فتح الدفع…',
    'pro.unavailable': 'الدفع غير متاح الآن.',
    'pro.already': 'هذا الحساب لديه اشتراك بالفعل.',
    'billing.working': 'جارٍ تأكيد الاشتراك…',
    'billing.active': 'اشتراكك نشط.',
    'billing.cancel': 'تم إلغاء الدفع.',
    'billing.error': 'تعذر تأكيد الدفع.',
    'billing.dismiss': 'إغلاق',
    'pro.reminders': 'تذكيرات هادئة',
    'pro.pages': 'صفحات قوائم بلا حد',
    'pro.themes': 'مظاهر إضافية',
    'pro.later': 'ليس الآن',
    'pro.joined': 'أنت على القائمة',
    'pro.join': 'انضم إلى القائمة',
    'admin.kicker': 'الفوترة',
    'admin.back': 'العودة إلى اللوحة',
    'admin.overview': 'نظرة عامة',
    'admin.users': 'المستخدمون',
    'admin.plans': 'الباقات',
    'admin.subscriptions': 'الاشتراكات',
    'admin.transactions': 'المعاملات',
    'admin.mrr': 'الإيراد الشهري التقديري',
    'admin.activeSubs': 'الاشتراكات النشطة',
    'admin.collected': 'المحصّل هذا الشهر',
    'admin.activePlans': 'الباقات النشطة',
    'admin.stripe': 'Stripe غير متصل بعد. الباقات والاشتراكات والمدفوعات هنا جاهزة للربط لاحقًا.',
    'admin.stripeTest': 'وضع اختبار Stripe متصل. كل عملية دفع تُحفظ في هذا السجل.',
    'admin.stripeLive': 'وضع Stripe المباشر متصل. كل عملية دفع تُحفظ في هذا السجل.',
    'admin.webhookOff': 'أضف سر الويب هوك لتسجيل التجديدات والاسترداد تلقائيًا.',
    'admin.payments': 'المدفوعات',
    'admin.events': 'أحداث Stripe',
    'admin.search': 'بحث',
    'admin.from': 'من',
    'admin.to': 'إلى',
    'admin.min': 'الأدنى',
    'admin.max': 'الأعلى',
    'admin.any': 'الكل',
    'admin.apply': 'تطبيق',
    'admin.clear': 'مسح',
    'admin.matches': '{n} نتيجة',
    'admin.noMatches': 'لا توجد نتائج لهذه التصفية.',
    'admin.loadMore': 'عرض المزيد',
    'admin.stripeId': 'Stripe',
    'admin.event': 'الحدث',
    'admin.message': 'الرسالة',
    'admin.recent': 'أحدث المعاملات',
    'admin.empty': 'لا يوجد شيء هنا بعد.',
    'admin.loading': 'جارٍ التحميل…',
    'admin.forbidden': 'ليست لديك صلاحية لوحة الإدارة.',
    'admin.loadError': 'تعذر تحميل لوحة الإدارة.',
    'admin.saveError': 'تعذر الحفظ. راجع الحقول ثم أعد المحاولة.',
    'admin.userMissing': 'لا يوجد حساب بهذا البريد.',
    'admin.showProPlans': 'إظهار الباقات في زر برو',
    'admin.role': 'الصلاحية',
    'admin.role.user': 'عضو',
    'admin.role.admin': 'مدير',
    'admin.joined': 'تاريخ التسجيل',
    'admin.you': 'أنت',
    'admin.noPlan': 'بلا باقة',
    'admin.deleteUser': 'حذف',
    'admin.confirmDelete': 'تأكيد الحذف',
    'admin.lastAdmin': 'أبقِ مديراً واحداً على الأقل.',
    'admin.newPlan': 'باقة جديدة',
    'admin.editPlan': 'تعديل الباقة',
    'admin.newSub': 'اشتراك جديد',
    'admin.newTx': 'معاملة جديدة',
    'admin.save': 'حفظ',
    'admin.saving': 'جارٍ الحفظ…',
    'admin.cancel': 'إلغاء',
    'admin.name': 'الاسم',
    'admin.description': 'الوصف',
    'admin.price': 'السعر',
    'admin.currency': 'العملة',
    'admin.interval': 'الفوترة',
    'admin.month': 'شهري',
    'admin.year': 'سنوي',
    'admin.active': 'نشطة',
    'admin.inactive': 'مخفية',
    'admin.customer': 'بريد العميل',
    'admin.status': 'الحالة',
    'admin.periodEnd': 'نهاية الفترة',
    'admin.amount': 'المبلغ',
    'admin.note': 'ملاحظة',
    'admin.plan': 'الباقة',
    'admin.when': 'التاريخ',
    'admin.stripePrice': 'معرّف سعر Stripe',
    'admin.optional': 'اتركه فارغًا لينشئ Stripe السعر.',
    'admin.paidCount': '{n} ناجحة',
    'admin.status.trialing': 'تجريبية',
    'admin.status.active': 'نشط',
    'admin.status.past_due': 'متأخر',
    'admin.status.canceled': 'ملغى',
    'admin.status.incomplete': 'غير مكتمل',
    'admin.status.pending': 'قيد الانتظار',
    'admin.status.succeeded': 'ناجحة',
    'admin.status.failed': 'فاشلة',
    'admin.status.refunded': 'مستردة',
    'admin.status.paused': 'متوقف',
    'admin.status.processed': 'تمت المعالجة',
    'admin.status.ignored': 'تم التجاهل',
  },
};

export function translate(lang, key, vars) {
  const catalog = messages[lang] || messages.en;
  let value = catalog[key] ?? messages.en[key] ?? key;
  if (vars) {
    Object.keys(vars).forEach((name) => {
      value = value.split(`{${name}}`).join(String(vars[name]));
    });
  }
  return value;
}

export function normalizeLang(language) {
  return language === 'ar' ? 'ar' : 'en';
}
